<div class="ads">
  <app-container>
    <div class="ads-wrapper">
      @for (item of announcements(); track item) {
        <div class="item">
          <div class="date">{{ item.createdAt | date: "dd.MM.yyyy" }}</div>
          <div class="title">
            {{ item.title }}
          </div>
          <div
            class="desc"
            [innerHTML]="
              item.body.length > 50
                ? item.body.slice(0, 300) + '...'
                : item.body
            "
          ></div>
          <div class="buttons">
            <button
              (click)="openModal(item.id)"
              class="_btn outline medium black"
            >
              <img src="assets/img/icons/envelope.svg" alt="" />
              Подати
            </button>
            <img class="line" src="assets/img/icons/line.svg" alt="line" />
            <img
              [routerLink]="['/announcement', item.alias]"
              class="arrow"
              src="assets/img/icons/arrow-right.svg"
              alt=""
            />
          </div>
        </div>
      }
    </div>
    <app-paginator
      [currentPage]="currentPage"
      [itemsPerPage]="itemsPerPage"
      [totalItems]="totalItems"
      (pageChange)="onPageChange($event)"
    >
    </app-paginator>
  </app-container>
</div>
